import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select", "nameField"]

  connect() {
    this.loadChannels()
  }

  async loadChannels() {
    if (!this.hasSelectTarget) return

    try {
      const response = await fetch("/connected_account_actions/slack_channels", {
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      if (response.ok) {
        const channels = await response.json()
        const currentValue = this.selectTarget.dataset.currentValue || ""
        const options = ['<option value="">None (don\'t post to Slack)</option>']
        channels.forEach(ch => {
          const label = `${ch.is_private ? "🔒 " : "#"}${ch.name}`
          const selected = ch.id === currentValue ? " selected" : ""
          options.push(`<option value="${ch.id}" data-name="${ch.name}"${selected}>${label}</option>`)
        })
        this.selectTarget.innerHTML = options.join("")
      }
    } catch (error) {
      console.error("Failed to load Slack channels:", error)
    }
  }

  updateName() {
    if (!this.hasNameFieldTarget || !this.hasSelectTarget) return
    const selected = this.selectTarget.selectedOptions[0]
    this.nameFieldTarget.value = selected ? selected.dataset.name || "" : ""
  }
}
